import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "hash",
  base: "/dist",
  routes: [
    {
      path: "/:lang/m8host",
      name: "M8host",
      component: () => import("@/views/m8host/index.vue"),
      meta: {
        title: "M8 HOST",
      },
    },
    {
      path: "/site/:id",
      name: "ProductSite",
      component: () => import("@/views/product/index.vue"),
      meta: {
        title: "M8 DeskPhone",
      },
    },
    {
      path: "/:lang/product/:id",
      name: "Product",
      component: () => import("@/views/product/index.vue"),
      meta: {
        title: "M8 DeskPhone",
      },
    },
    {
      path: "/:lang/ah80",
      name: "AH80",
      component: () => import("@/views/ah80/index.vue"),
      meta: {
        title: "AH80",
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
